<!-- Localized -->
<template>
  <div>
    <div
      class="flex border-1.5 border rounded-lg text-sm"
    >
      <div class="flex w-full p-2">
        <div class="flex w-12 h-28 items-center px-2 justify-center">
          <div class="mb-4">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 12C18 15.3137 15.3137 18 12 18C8.68628 18 6 15.3137 6 12C6 8.68628 8.68628 6 12 6C15.3137 6 18 8.68628 18 12ZM11.306 15.177L15.7576 10.7253C15.9088 10.5742 15.9088 10.3291 15.7576 10.1779L15.2102 9.63048C15.059 9.4793 14.8139 9.4793 14.6627 9.63048L11.0323 13.2609L9.33728 11.5659C9.18612 11.4148 8.94102 11.4148 8.78983 11.5659L8.2424 12.1134C8.09124 12.2645 8.09124 12.5096 8.2424 12.6608L10.7585 15.1769C10.9097 15.3281 11.1548 15.3281 11.306 15.177Z" fill="#282828"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7386 18.6919C18.6418 18.7838 18.5433 18.8732 18.4433 18.9601L19.0771 19.5692C21.5063 17.4051 22.8106 14.1168 22.4333 10.8318C21.9457 6.58082 18.7051 3.01008 14.5157 2.10899C13.7549 1.94421 12.9698 1.86954 12.1922 1.88702L13.3588 0.756585C13.7652 0.360071 13.152 -0.270689 12.7459 0.126205L10.6996 2.10967C10.5131 2.2884 10.5274 2.59486 10.7207 2.76244L12.8995 4.59087C13.3351 4.95814 13.9002 4.28212 13.4666 3.91828L12.0971 2.76983C16.0794 2.64326 19.7726 5.176 21.0962 8.92965C22.2956 12.3185 21.3527 16.2131 18.7386 18.6919ZM1.56429 13.1682C1.18593 9.87375 2.49883 6.57595 4.94156 4.41213L5.57565 5.02154C5.46825 5.11419 5.36264 5.20972 5.25896 5.30813C2.64489 7.78692 1.70203 11.6816 2.90137 15.0704C4.22494 18.824 7.91817 21.3568 11.9005 21.2302L10.531 20.0818C10.0973 19.7179 10.6624 19.0419 11.0981 19.4092L13.2768 21.2376C13.4701 21.4052 13.4845 21.7116 13.298 21.8904L11.2517 23.8738C10.8456 24.2707 10.2324 23.64 10.6387 23.2435L11.8054 22.113C11.0278 22.1305 10.2427 22.0558 9.48187 21.8911C5.29248 20.99 2.05191 17.4192 1.56429 13.1682Z" fill="#282828"/>
            </svg>
          </div>
        </div>
        <div class="flex flex-col w-full justify-center">
          <div class="flex justify-between items-baseline pb-1">
            <div class="flex text-blue-600 py-1">{{ item.entity_name }}</div>
            <div class="pr-2 text-gray-400 text-xs">{{ getDateAndTime() }}</div>
          </div>
          <div class="flex pb-1">
            {{ item?.to?.user_name }}
            <span class="px-1 text-gray-400">{{ $t('case_creation.updated_risk_label') }}</span>
          </div>
          <div class="flex pb-1">
            {{ $t('case_creation.updated_risk_label_note') }}
            <span class="px-1 text-gray-400">{{ item?.to?.reason }}</span>
          </div>
          <div class="flex flex-start gap-4 pt-2 items-center text-xs">
            <div class="flex justify-between items-baseline gap-2.5">
              <div
                class="text-base font-medium tracking-wide text-base-content flex items-center gap-2 px-2 py-0.5 rounded-md"
                v-if="item.from"

                :style="{ 'background-color': item.from.label_color }"
              >
                <span
                  class="active-state truncate text-sm text-white"
                  :title="item.from.label_name"
                >
                  {{ item.from.label_name }}
                </span>
              </div>
              <div class="self-center">
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                  />
                </svg>
              </div>
              <div
                class="text-base font-medium tracking-wide text-base-content flex items-center gap-2 px-2 py-0.5 rounded-md"
                v-if="item.to"

                :style="{ 'background-color': item.to.label_color }"
              >
                <span
                  class="active-state truncate text-sm text-white"
                  :title="item.to.label_name"
                >
                  {{ item.to.label_name }}
                </span>
              </div>
            </div>
            <div
              class="flex p-1 rounded-lg text-[#282828] font-medium"
              style="background-color: #F2F2F2;"
            >
              <p>
                {{ $t('components.dashboard.time_in_source') }}
                <span class="text-blue-600">{{ updatedTimeDiff }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getDateDifference} from "@shared/utils/functions"
import { formatUtcDate, DATETIME_FORMAT_3 } from "@shared/utils/dateTime";
import { mapGetters } from "vuex";
export default {
  name: "case-logs",
  props: {
    item: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getCaseData", "getSelectedEntity"]),

    updatedTimeDiff() {
      if (!this.item.from?.created_at || !this.item.to?.created_at) return '';
      return getDateDifference(this.item.from.created_at, this.item.to.created_at);
    }
  },
  methods: {
    getDateAndTime() {
      const date = this.item?.to?.created_at;
      return date ? formatUtcDate(date, { format: DATETIME_FORMAT_3 }) : '';
    },
  },
};
</script>
